angular.module("moteur/composants/operiaChat/operiaChat.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("moteur/composants/operiaChat/operiaChat.html",
    "<style>.operiaChat {\n" +
    "        bottom: 0px;\n" +
    "        position: absolute;\n" +
    "        right: 0px;\n" +
    "        display: flex;\n" +
    "        flex-direction: row;\n" +
    "        height: 400px;\n" +
    "        background-color: #d2d6de;\n" +
    "    }\n" +
    "    \n" +
    "    #userList {\n" +
    "        background-color: white;\n" +
    "        margin-right: 2px;\n" +
    "    }\n" +
    "    \n" +
    "    .chatColumn {\n" +
    "        background-color: white;\n" +
    "        width: 270px;\n" +
    "        height: 400px;\n" +
    "        margin: 0px 1px 0px 0px;\n" +
    "    }\n" +
    "    \n" +
    "    .chatColumnReduced {\n" +
    "        height: 0px;\n" +
    "        position: absolute;\n" +
    "        bottom: 15px;\n" +
    "        right: 0px;\n" +
    "    }\n" +
    "    \n" +
    "    li.chatBubble {\n" +
    "        border-radius: 5px;\n" +
    "        position: relative;\n" +
    "        padding: 5px 10px;\n" +
    "        margin: 5px 0px 10px 0px;\n" +
    "    }\n" +
    "    \n" +
    "    li.chatBubble::after {\n" +
    "        display: block;\n" +
    "        position: relative;\n" +
    "        background-repeat: no-repeat;\n" +
    "        content: \" \";\n" +
    "        top: -13px;\n" +
    "        height: 10px;\n" +
    "        width: 10px;\n" +
    "    }\n" +
    "    \n" +
    "    li.chatReceived {\n" +
    "        background: #d2d6de;\n" +
    "        border: 1px solid #d2d6de;\n" +
    "        margin-right: 20px;\n" +
    "        color: #444;\n" +
    "    }\n" +
    "    \n" +
    "    li.chatReceived::after {\n" +
    "        background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' height='10' width='10'><polygon points='1,5 9,1 9,9' style='fill:%23d2d6de;stroke:%23d2d6de;stroke-width:1' /> </svg>\");\n" +
    "        left: -20px;\n" +
    "    }\n" +
    "    \n" +
    "    li.chatSended {\n" +
    "        position: relative;\n" +
    "        border: 1px solid #f39c12;\n" +
    "        margin-left: 28px;\n" +
    "        background: #f39c12;\n" +
    "        color: #fff;\n" +
    "    }\n" +
    "    \n" +
    "    li.chatSended::after {\n" +
    "        background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' height='10' width='10'><polygon points='1,1 1,9 9,5' style='fill:%23f39c12;stroke:%23f39c12;stroke-width:1' /> </svg>\");\n" +
    "        left: 210px;\n" +
    "    }\n" +
    "    \n" +
    "    li {\n" +
    "        margin-left: 0px;\n" +
    "    }\n" +
    "    \n" +
    "    .title {\n" +
    "        background-color: #0f9d58;\n" +
    "        text-align: center;\n" +
    "        height: 30px;\n" +
    "        line-height: 30px;\n" +
    "        text-decoration: none;\n" +
    "        color: black;\n" +
    "    }\n" +
    "    \n" +
    "    .disconnected {\n" +
    "        background-color: #ace7cb;\n" +
    "    }\n" +
    "    \n" +
    "    a.chatuser {\n" +
    "        text-decoration: none;\n" +
    "        color: black;\n" +
    "    }\n" +
    "    \n" +
    "    ul.chatuser {\n" +
    "        list-style: none;\n" +
    "        padding: 10px;\n" +
    "        margin: 0px;\n" +
    "        height: 315px;\n" +
    "        overflow-y: scroll;\n" +
    "    }\n" +
    "    \n" +
    "    li.chatuser {\n" +
    "        list-style-type: none;\n" +
    "        min-height: 50px;\n" +
    "        background-image: url(img/avatar.png);\n" +
    "        background-repeat: no-repeat;\n" +
    "        padding-top: 5px;\n" +
    "        padding-left: 50px;\n" +
    "    }\n" +
    "    \n" +
    "    .chatinput {\n" +
    "        font-size: 14px;\n" +
    "        border: 0px;\n" +
    "        background-color: #eceff1;\n" +
    "        height: 30px;\n" +
    "        padding-left: 10px;\n" +
    "        padding-right: 10px;\n" +
    "        width: 250px;\n" +
    "    }\n" +
    "    \n" +
    "    .chatinput:focus {\n" +
    "        outline: none;\n" +
    "    }\n" +
    "    \n" +
    "    .chatcamera {\n" +
    "        width: 30px;\n" +
    "        height: 30px;\n" +
    "        float: right;\n" +
    "        margin-right: 5px;\n" +
    "    }\n" +
    "    \n" +
    "    .chatVideoButton {\n" +
    "        height: 45px;\n" +
    "        width: 45px;\n" +
    "    }\n" +
    "    \n" +
    "    .chatVideoButtons {\n" +
    "        margin-top: 5px;\n" +
    "        display: flex;\n" +
    "        flex-direction: row;\n" +
    "        justify-content: space-around;\n" +
    "    }\n" +
    "    /**\n" +
    "    *   Mobile specific \n" +
    "    */\n" +
    "    \n" +
    "    @media screen and (max-width: 600px) {\n" +
    "        .operiaChat {\n" +
    "            height: 200px;\n" +
    "        }\n" +
    "        .chatColumn {\n" +
    "            width: 150px;\n" +
    "            height: 200px;\n" +
    "        }\n" +
    "        li.chatuser {\n" +
    "            min-height: 30px;\n" +
    "            padding-top: 3px;\n" +
    "            padding-left: 35px;\n" +
    "            background-size: 30px;\n" +
    "        }\n" +
    "        ul.chatuser {\n" +
    "            height: 115px;\n" +
    "        }\n" +
    "        li.chatSended::after {\n" +
    "            left: 89px;\n" +
    "        }\n" +
    "        .chatVideoButton {\n" +
    "            height: 25px;\n" +
    "            width: 25px;\n" +
    "        }\n" +
    "        .chatColumnReduced {\n" +
    "            height: 0px;\n" +
    "            position: absolute;\n" +
    "            bottom: 15px;\n" +
    "            right: 0px;\n" +
    "        }\n" +
    "    }</style><div><div id=\"operiaChat\" class=\"operiaChat\" ng-show=\"active\" ng-class=\"{chatColumnReduced : userList.minimized == true}\"><div class=\"chatColumn\" ng-repeat=\"chat in chats\" ng-show=\"chat.minimized != true\"><a class=\"chatuser\" href=\"\" ng-click=\"toggle(chat.uuid)\"><div class=\"title\" ng-class=\"{disconnected: wsConnected==false, disconnected: chat.isOnline==false}\"><span>{{ chat.login }}</span><img ng-click=\"videoChat(chat.uuid)\" ng-show=\"webRtcCompliant && chat.webrtcCompliant\" class=\"chatcamera\" src=\"img/camera.svg\"></div></a><ul class=\"chatuser\" scroll-down><li ng-repeat=\"msg in chat.messages\" class=\"chatBubble\" ng-class=\"{chatSended: msg.sended==true, chatReceived: msg.sended==false}\"><span ng-show=\"msg.video==false\">{{ msg.text }}</span><div ng-show=\"msg.video==true\"><span ng-show=\"msg.state == 0\">Demande de chat vidéo</span><div ng-show=\"msg.sended==false && msg.state == 0\" class=\"chatVideoButtons\"><a ng-click=\"hangupVideoChat(msg)\" href=\"\"><img class=\"chatVideoButton\" src=\"img/reject.png\"></a> <a ng-click=\"answerVideoChat(msg)\" href=\"\"><img class=\"chatVideoButton\" src=\"img/accept.png\"></a></div><span ng-show=\"msg.state == 1\">Demande de chat vidéo acceptée</span> <span ng-show=\"msg.state == 2\">Demande de chat vidéo refusée</span></div></li></ul><div style=\"margin:auto;background-color: #eceff1\"><input type=\"text\" autofocus id=\"chatMessage\" class=\"chatinput\" placeholder=\"Votre message ici...\" ng-model=\"chat.message\" ng-keydown=\"sendMessage($event, chat.uuid, chat.message)\"></div></div><div id=\"userList\" class=\"chatColumn\" ng-class=\"{chatColumnReduced : userList.minimized == true}\"><a class=\"chatuser\" ng-click=\"toggleList()\"><div class=\"title\" ng-class=\"{disconnected: wsConnected==false}\">Chat Opéria <span class=\"navbar-btn fa fa-times fa-margin-right pull-right\" ng-click=\"$event.stopPropagation();hide()\"></span></div></a><ul class=\"chatuser\" ng-show=\"userList.minimized == false\"><a ng-repeat=\"user in users\" class=\"chatuser\" href=\"\" ng-click=\"chatWith(user.uuid, user.login, user.webrtcCompliant)\"><li class=\"chatuser\">{{ user.login }}</li></a></ul></div></div></div>");
}]);
